import MoreIcon from '../../../../../assets/icons/more.svg?react';
import { FileCardStyle, FileContainer, MenuListStyle } from './style';
import { Popover } from 'react-tiny-popover';
import { useMemo, useRef, useState } from 'react';
import { IoIosArrowUp } from 'react-icons/io';
import { LuGripVertical, LuPlus } from 'react-icons/lu';
import { SheetSelect } from '../SheetSelect';
import { SHEET_ROW_HEIGHT } from '../../utils';
import { FiTrash2 } from 'react-icons/fi';
import { newEmptySheet } from '../../hooks/useAutomationFiles';
import { MoonLoader } from 'react-spinners';
import Skeleton from 'react-loading-skeleton';
import { TbDownload, TbReplace, TbFiles, TbFile } from 'react-icons/tb';
import { Flex, Box, Tooltip } from '@mantine/core';
import styled from 'styled-components';
import reportStore from '../../store';
import { createStyles } from '@mantine/emotion';
import { SPREADSHEET_FILE_ACCEPT } from '../../../../../consts/fileTypes';

const useStyles = createStyles(() => ({
  uploadType: {
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4
  }
}));

export function UnmappedFileCard({
  isCustomReportType,
  name,
  isCurrentFund = false,
  isOpenSheet,
  onOpenSheet,
  showDrag = false,
  mappedSheets = [],
  notMappedSheets = [],
  onChooseSheet,
  isMultiUpload,
  sources,
  handleAddMappedSheet,
  handleSelectSource,
  handleRemoveMappedSheet,
  dragProps,
  extraRows,
  currentFileId,
  onDeleteFile,
  onDeleteSheet,
  isLoading,
  handleReplaceFile,
  handleDownloadFile,
  acceptedFileTypes = SPREADSHEET_FILE_ACCEPT,
  canManageWorkflow = true,
  onOpenUploadFlow
}) {
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenDeleteSheet, setIsOpenDeleteSheet] = useState(null);

  const onOpenDelete = () => {
    setIsOpenDelete(true);
  };

  const onOpenDeleteSheet = value => {
    setIsOpenDeleteSheet(value);
  };

  const onCloseDeleteSheet = () => {
    setIsOpenDeleteSheet(null);
  };

  const onCloseDelete = () => {
    setIsOpenDelete(false);
  };

  const onReplaceFile = e => {
    handleReplaceFile(e, currentFileId);
  };

  const onDownloadFile = () => {
    onCloseDelete();
    handleDownloadFile(currentFileId, name);
  };

  const { isLockedPeriod } = reportStore;

  const disableAdding = useMemo(() => {
    const mocks = mappedSheets.filter(sheet => sheet.id === 0);

    return mocks.length === notMappedSheets.length;
  }, [notMappedSheets, mappedSheets, isCurrentFund]);

  const mutatedNotMappedSheets = useMemo(() => {
    function filterUniqueArray(data) {
      const seen = new Set(); // Set to track unique entries
      const result = []; // Result array to store filtered entries

      data.forEach(item => {
        const uniqueKey = item?.id;

        if (!seen.has(uniqueKey)) {
          seen.add(uniqueKey); // Mark this combination as seen
          result.push(item); // Add to the result
        }
      });

      return result;
    }

    return filterUniqueArray([{ ...newEmptySheet }, ...(notMappedSheets || [])]);
  }, [notMappedSheets]);

  function renderExtraRows() {
    return Array(extraRows)
      .fill()
      .map((_, index) => <ExtraRow key={'extra_row' + index} />);
  }

  function renderSkeleton() {
    return Array(extraRows)
      .fill()
      .map((_, index) => (
        <StyledSkeleton key={'extra_row' + index} height={SHEET_ROW_HEIGHT} width="220px" />
      ));
  }

  const replaceInputRef = useRef();

  const onClickReplaceFile = () => {
    setIsOpenDelete(false);

    if (onOpenUploadFlow) {
      onOpenUploadFlow({
        openLocalPicker: () => replaceInputRef.current?.click()
      });
      return;
    }

    replaceInputRef.current?.click();
  };

  const handleDeleteFile = () => {
    onDeleteFile(currentFileId, name);
    onCloseDelete();
  };

  const handleClearSheet = (item, index) => {
    onDeleteSheet(item.id, index, currentFileId);
    onCloseDeleteSheet();
  };

  const { classes } = useStyles();

  return (
    <FileContainer key={'isDisableAddingOn_' + disableAdding}>
      <FileCardStyle isLoading={isLoading}>
        {!isLoading && showDrag && !isLockedPeriod && canManageWorkflow ? (
          <button {...(dragProps || {})}>
            <LuGripVertical fontSize="20px" color="#C1C2C5" />
          </button>
        ) : (
          <span style={{ width: 21.5 }} />
        )}

        {isLoading ? (
          <Flex align="center" justify="center">
            <MoonLoader size={18} color="#1971c2" />
          </Flex>
        ) : (
          <ToggleSheetButton onClick={onOpenSheet}>
            <IoIosArrowUp color="#C1C2C5" />
          </ToggleSheetButton>
        )}

        {/* Replace input start */}

        <input
          style={{ display: 'none' }}
          ref={replaceInputRef}
          type="file"
          multiple={false}
          accept={acceptedFileTypes}
          onChange={onReplaceFile}
        />

        {/* Replace input end */}

        <div className="file-box">
          <div className="file-name">
            <p data-tooltip-content={name} data-tooltip-id="ligth-tooltip">
              {name}
            </p>
            {!isCustomReportType && (
              <Tooltip label={isMultiUpload ? 'Multi-Upload' : 'Single-Upload'}>
                <Box className={classes.uploadType} bg="#F1F3F5">
                  {isMultiUpload ? (
                    <TbFiles size={16} color="#5C5F66" />
                  ) : (
                    <TbFile size={16} color="#5C5F66" />
                  )}
                </Box>
              </Tooltip>
            )}
          </div>

          {!isLoading && isCurrentFund && (
            <Popover
              isOpen={isOpenDelete}
              positions={['bottom', 'center']}
              onClickOutside={onCloseDelete}
              content={
                <MenuListStyle>
                  {canManageWorkflow && !isLockedPeriod && (
                    <button onClick={onClickReplaceFile} className="menu-item">
                      <TbReplace />
                      Replace
                    </button>
                  )}
                  <button onClick={onDownloadFile} className="menu-item">
                    <TbDownload />
                    Download
                  </button>
                  {canManageWorkflow && !isLockedPeriod && (
                    <div onClick={handleDeleteFile} className="menu-item delete">
                      <FiTrash2 />
                      Delete
                    </div>
                  )}
                </MenuListStyle>
              }
            >
              <button onClick={onOpenDelete}>
                <MoreIcon />
              </button>
            </Popover>
          )}
        </div>
      </FileCardStyle>

      {isOpenSheet && (
        <div className="sheets">
          {!isLoading &&
            mappedSheets?.map((item, index) => (
              <SheetSelect
                key={'unmapped_sheet-' + index}
                name={item.name}
                isOpenPopover={isOpenDeleteSheet === (item.id || index)}
                isDisabled={!isCurrentFund || isLockedPeriod || !canManageWorkflow}
                showMore={isCurrentFund && !isLockedPeriod && canManageWorkflow}
                showSourceSelect={true}
                sources={sources}
                options={mutatedNotMappedSheets.filter(el => !!el)}
                selectedSource={item.source}
                onChangeSource={value => handleSelectSource(item?.id, value)}
                handleRemove={() => handleRemoveMappedSheet(index)}
                onChange={el => onChooseSheet(index, el)}
                onClear={() => handleClearSheet(item, index)}
                onClickMore={() => onOpenDeleteSheet(item.id || index)}
                onClosePopover={onCloseDeleteSheet}
              />
            ))}

          {isLoading &&
            mappedSheets?.map((_, index) => (
              <StyledSkeleton key={'extra_row' + index} height={SHEET_ROW_HEIGHT} width="220px" />
            ))}

          {!disableAdding &&
            isCurrentFund &&
            notMappedSheets?.length > 0 &&
            !isLockedPeriod &&
            canManageWorkflow && (
              <div className="sheet-item">
                <div className="sheet-wrapper">
                  <div className="control" style={{ height: 24 }}>
                    <button className="plus-btn" onClick={handleAddMappedSheet}>
                      <LuPlus />
                    </button>
                  </div>
                </div>
              </div>
            )}

          {!isLoading && renderExtraRows()}

          {isLoading && renderSkeleton()}
        </div>
      )}
    </FileContainer>
  );
}

const ExtraRow = styled.div`
  width: 100%;
  height: ${SHEET_ROW_HEIGHT}px;
`;

const StyledSkeleton = styled(Skeleton)`
  margin-left: 99px;
  opacity: 0.5;
`;

const ToggleSheetButton = styled.button`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
  transition: transform 0.2s ease;
`;
